import React from 'react'
import Flash from './Flash'

export default function AuthLayout({ children, backgroundImage }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundColor: backgroundImage ? undefined : '#075669'
      }}
    >
      <Flash />
      <div className="w-full max-w-md px-4 py-8">
        {children}
      </div>
    </div>
  )
}
